import React, {useEffect} from 'react'
import {Nav, Navbar, NavItem} from 'react-bootstrap'
import style from './Layout.scss'

import {logout} from "@/util/authentication";
import {useHistory} from "react-router";
import {isNoNeedLogins} from "@/routes";
import {isLogin} from "@/util/authentication";

const Layout = ({category = 'WA', needTopBar = true, title, children}) => {
  const history = useHistory()
  const pathName = history.location.pathname

  useEffect(() => {
    (async () => {
      const noNeedLogin = isNoNeedLogins(pathName)
      if (noNeedLogin) {
        return
      }

      const login = await isLogin()
      if (!login) {
        doLogout()
      }
    })()
  }, [pathName])

  const doLogout = (e) => {
    logout()
    document.location.href = '/'
  }

  return (
    <>
      {
        needTopBar &&
        <Navbar className={`me-auto ${style.topBar}`}>
          <Nav className="me-auto">
            <NavItem className={style.brand}>
              名刺R
              { category && `- ${category}`}
              { title && `- ${title}`}
            </NavItem>
          </Nav>
        </Navbar>
      }
      <div className="contents">
        <section className={style.pageContainer}>
          <main>{children}</main>
        </section>
      </div>
    </>
  )
}

export default Layout
